import { API, auth, fmtDate, errMsg, inputCls, Field, Modal, PageHead, PrimaryBtn, Paginator, exportExcel, exportPdf, printArea, PrintStyle } from '../../organization/finance/shared';

export { API, auth, fmtDate, errMsg, inputCls, Field, Modal, PageHead, PrimaryBtn, Paginator, exportExcel, exportPdf, printArea, PrintStyle };

export const LEVEL_LABELS = { beginner: 'مبتدئ', intermediate: 'متوسط', advanced: 'متقدم' };
export const EXERCISE_STATUS_LABELS = { draft: 'مسودة', ready: 'جاهز', archived: 'مؤرشف' };
export const VISIBILITY_LABELS = { private: 'خاص', staff: 'مشارك مع الطاقم', organization: 'مشارك مع المنشأة', public: 'عام' };
export const PLAN_TYPE_LABELS = { daily: 'يومية', weekly: 'أسبوعية', monthly: 'شهرية', prep_period: 'فترة إعداد', seasonal: 'موسمية' };
export const PLAN_STATUS_LABELS = { draft: 'مسودة', pending_approval: 'بانتظار الاعتماد', approved: 'معتمدة', changes_requested: 'مطلوب تعديل', active: 'نشطة', completed: 'مكتملة', archived: 'مؤرشفة' };
export const SESSION_STATUS_LABELS = { draft: 'مسودة', scheduled: 'مجدولة', started: 'بدأت', completed: 'مكتملة', cancelled: 'ملغاة' };
export const DAY_TYPE_LABELS = { training: 'تدريب', rest: 'راحة', match: 'مباراة' };

export const SESSION_STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-500', scheduled: 'bg-blue-50 text-blue-700', started: 'bg-amber-50 text-amber-700',
  completed: 'bg-teal-50 text-teal-700', cancelled: 'bg-red-50 text-red-600',
};
export const PLAN_STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-500', pending_approval: 'bg-amber-50 text-amber-700', approved: 'bg-blue-50 text-blue-700',
  changes_requested: 'bg-red-50 text-red-600', active: 'bg-teal-50 text-teal-700', completed: 'bg-slate-100 text-slate-600', archived: 'bg-slate-100 text-slate-400',
};

export const StatusPill = ({ status, labels, colors }) => (
  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${colors[status] || 'bg-slate-100 text-slate-600'}`}>{labels[status] || status}</span>
);

export const StudioEmpty = ({ text, icon }) => (
  <div className="flex flex-col items-center py-12 text-center" data-testid="studio-empty-state">
    <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400">
      {icon}
    </span>
    <p className="text-sm text-slate-500">{text}</p>
  </div>
);
